@import "config";

.baseColor {
	color: $color-dark-d1;
}

.display {
	font-size: $font-size-xl;

	&--v1 {
		@extend .display;
		font-weight: $font-weight-bold;
	}

	&--v2 {
		@extend .display;
		font-weight: $font-weight-regular;
	}
}

.heading {
	font-size: $font-size-lg;
	font-weight: $font-weight-bold;

	&--v1 {
		@extend .heading;
	}

	&--v2 {
		@extend .heading;
		font-size: $font-size-md;
	}

	&--v3 {
		@extend .heading;
		font-size: $font-size-sm;
	}

	&--v4 {
		@extend .heading;
		font-size: $font-size-sm;
		font-weight: $font-weight-regular;
	}

	&--v5 {
		@extend .heading;
		font-size: $font-size-xs;
	}
}

.paragraph {
	&--v1 {
		@extend .paragraph;
		font-size: $font-size-xs;
		font-weight: $font-weight-regular;
	}

	&--v2 {
		@extend .paragraph;
		font-size: $font-size-xxs;
		font-weight: $font-weight-bold;
	}

	&--v3 {
		@extend .paragraph;
		font-size: $font-size-xxs;
		font-weight: $font-weight-regular;
	}

	&--v4 {
		@extend .paragraph;
		font-size: $font-size-xxs;
		font-weight: $font-weight-regular;
	}
}

.caption {
	font-size: $font-size-xxxs;

	&--v1 {
		@extend .caption;
		font-weight: $font-weight-bold;
	}

	&--v2 {
		@extend .caption;
		font-weight: $font-weight-regular;
	}
}
